import styled from "styled-components";

interface ISButtonProps{
  backgroundColor?: string;
  textColor?: string;
}

export const SButton = styled.button`
  border:none;
  outline:none;
  cursor:pointer;
  transition:0.1s ease-in-out;
  &:hover{
    transform:scale(1.02)
  }
  color:${(props:ISButtonProps)=>props.textColor};
  background:${(props: ISButtonProps) => props.backgroundColor ? props.backgroundColor : "#fff"};
  border-radius:0.6rem;
  border:1.5px solid ${(props:ISButtonProps)=>props.textColor};
  padding:0.56rem 2.3rem;
  font-size:0.9rem;
  font-family:${({ theme }) => theme.fontFamily.workSans};
  font-weight:${({ theme }) => theme.fontWeights.regular};
`;